// Moved verbatim from `src/utils/normalizeSessionData.ts` (which re-exports
// from here) with the D3 family; the app logger import became the runtime
// door.
import { logger } from '@heidi/runtime/logger';

import { type SessionResponse } from '../contracts';

/**
 * Normalizes session EHR provider during the migration period.
 *
 * `session.ehr_provider` was planned for deprecation, but existing records can still
 * be inconsistent while backend data is being backfilled. To keep frontend behavior stable,
 * this function prefers `patient_profile.ehr` and falls back to `session.ehr_provider` when
 * patient profile EHR is unavailable.
 *
 * When both values exist and differ, we log a warning to help track data inconsistencies.
 * Backend writes should still be updated to keep `session.ehr_provider` aligned over time.
 */
export function normalizeSessionEhrProvider(data: SessionResponse): SessionResponse {
  const patientProfileEhr = data.patient_profile?.ehr;

  if (patientProfileEhr && data.ehr_provider && data.ehr_provider !== patientProfileEhr) {
    logger.warn(
      'Session EHR provider mismatch detected, preferring patient profile EHR',
      {
        sessionId: data.session_id,
        sessionEhrProvider: data.ehr_provider,
        patientProfileEhrProvider: patientProfileEhr,
      }
    );
  }

  return {
    ...data,
    ehr_provider: patientProfileEhr ?? data.ehr_provider,
  };
}
